// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4GJqt","buttons":"styles_buttons__eENCo"};